<template>
  <div>
    <v-container fluid v-if="loading">
      <v-card class="app-card">
        <v-card-text class="pa-4">
          <v-row>
            <v-col cols="12" class="ma-auto text-center">
              <v-progress-circular :loading="loading"
                                   indeterminate
                                   color="primary"
                                   size="64"
                                   width="2"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
    <div v-else>
      <basic-choice />
      <!-- New site selected -->
      <new-website v-if="newSiteSelected"/>
      <!-- New site selected alternative   -->
      <new-website-alt v-if="displayAltWebsite"/>
      <!-- Migration website selected   -->
      <migrate-website v-if="migrateSelected"/>
      <!-- Skip This selected -->
      <skip-this v-if="skipThisSelected"></skip-this>
      <!-- Starter Site -->
      <starter-site v-if="starterSiteSelected"></starter-site>
      <v-row>
        <v-col cols="12" class="text-center" v-if="showButtons.next">
          <gg-btn color="primary" elevation="0" tile @click="nextStep">
            Continue
          </gg-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import BasicChoice from '@/components/Wizard/StepOne/BasicChoice'
import NewWebsite from '@/components/Wizard/StepOne/NewWebsite'
import NewWebsiteAlt from '@/components/Wizard/StepOne/NewWebsiteAlt'
import MigrateWebsite from '@/components/Wizard/StepOne/MigrateWebsite'
import StarterSite from '@/components/Wizard/StepOne/StarterSite'
import SkipThis from '@/components/Wizard/StepOne/SkipThis'

export default {
  name: 'WizardStepOne',
  components: {
    BasicChoice,
    NewWebsite,
    NewWebsiteAlt,
    MigrateWebsite,
    SkipThis,
    StarterSite,
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    ...mapGetters({
      path: 'wizard_model/path',
      application: 'wizard_model/application',
      displayAltWebsite: 'wizard/website_alt_show',
      mode: 'wizard/mode',
    }),
    newSiteSelected () {
      return this.path === 'New Website'
    },
    migrateSelected () {
      return this.path === 'Migration'
    },
    skipThisSelected () {
      return this.path === 'Skip This'
    },
    starterSiteSelected () {
      return this.path === 'Starter Site'
    },
    showButtons () {
      if (this.migrateSelected || this.starterSiteSelected) {
        return {
          next: true
        }
      }

      if (this.path !== undefined && Object.keys(this.application).length === 0) {
        return {
          next: false
        }
      }

      if (this.path !== undefined && Object.keys(this.application).length !== 0) {
        return {
          next: true
        }
      }

      return {
        next: false
      }
    },
    showNextBtn () {
      if (this.path === 'Migration') return true

      return this.path !== undefined && Object.keys(this.application).length !== 0
    }
  },
  async mounted () {
    this.loading = true

    try {
      const serviceID = this.$route.query.serviceID
      await this.getApplications(serviceID)
    } catch (e) {
      await this.$router.push({ name: 'dashboard' })
    } finally {
      this.loading = false
    }
  },
  methods: {
    ...mapMutations({
      setStep: 'wizard/SET_STEP'
    }),
    ...mapActions({
      getApplications: 'wizard/getApplications',
      reportError: 'reportError'
    }),
    nextStep () {
      this.setStep(2)
    }
  }
}
</script>
